import React from 'react';
import PropTypes from 'prop-types';
import { connectCurrentRefinements } from 'react-instantsearch-dom';
import clsx from 'clsx';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import Icon from '../../Icon';
import Button from '../../Button';

// eslint-disable-next-line react/prop-types
const DeleteButton = ({ onClick }) => (
  <Button color="link" className="p-0 text-dark ml-8" style={{ lineHeight: 0 }} onClick={onClick}>
    <Icon icon={faTimes} />
  </Button>
);

const CurrentRefinements = ({ items, canRefine, refine, className, labelTranslations }) => (
  <div className={clsx({ 'd-none': !canRefine }, className)}>
    <ul className="list-unstyled m-0 d-flex flex-wrap m-n4">
      {items.map(item =>
        item.items.map(nest => (
          <li key={item.label} className="p-4">
            <span className="badge badge-light d-flex align-items-center">
              <span className="mr-4">{labelTranslations[item.label.replace(':', '').trim()]}:</span>{' '}
              <span>{nest.label}</span>
              <DeleteButton onClick={() => refine(nest.value)} />
            </span>
          </li>
        )),
      )}
    </ul>
  </div>
);

CurrentRefinements.propTypes = {
  canRefine: PropTypes.bool,
  className: PropTypes.string,
  items: PropTypes.array,
  labelTranslations: PropTypes.object,
  refine: PropTypes.func,
};

CurrentRefinements.defaultProps = {
  canRefine: false,
  className: undefined,
  items: [],
  labelTranslations: [],
  refine: undefined,
};

export default connectCurrentRefinements(CurrentRefinements);
